{
  "id": "odin",
  "pantheon": "norse",
  "name": {
    "pt-BR": "Odin",
    "en": "Odin"
  },
  "icon": "gods/odin",
  "portrait": "gods/odin-portrait",
  "modifiers": [
    {
      "target": "gatherRate",
      "op": "pct",
      "value": 0.1,
      "scope": {
        "ids": ["gatherer", "dwarf"],
        "sources": ["hunt"]
      },
      "note": "Hunters gather 10% faster."
    }
  ],
  "powers": ["great-hunt"],
  "minors": {
    "classical": ["freyja", "heimdall"],
    "heroic": ["skadi", "njord"],
    "mythic": ["baldr", "tyr"]
  },
  "unlocks": ["hamask"],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "ArchaicAgeOdin: Great Hunt (cooldown 90); hunt x1.1 BasePercent for EconomicUpgraded (modifier). Not expressed as modifiers: Hersir, Jarl, Godi and Raiding Cavalry earn combat favor x1.25 (1 per 64 damage, major_gods.xml); human soldiers and heroes regenerate 0.4 HP/s; 2 Ravens spawn at the first Temple (RavenFirstSpawn) and respawn (RavenRespawn), +2 LOS each age."
  }
}
